import { ApplicationStages } from "constant/AppConstants";

const apiRequest =
  process.env.REACT_APP_STAGE === ApplicationStages.local
    ? `http://localhost:8000`
    : `${process.env.REACT_APP_BACKEND_API}`;

const ApiCalls = {
  ConfirmEditCall: "editProviderAppointment",
  ConfirmCancelCall: "cancelProviderAppointment",
  ConfirmAddCall: "createproviderappt",
  CalculateMileage: "calculatemileage",
  ProviderAppointments: "providerappointments",
  ConfirmConversionCall: "checkifeventconverted",
  PatientConfirmConversionCall: "patientPortalCheckIfEventConverted",
  ConfirmDayCall: "confirmBiAppointments",
  SetShiftAvailabilityCall: "setShiftAvailability",
  ProviderCurrentShiftsCall: "providerCurrentShifts",
  AdditionalAvailabilityCall: "additionalAvailability",
  SaveShiftChangeRequestCall: "saveShiftChangeRequest",
  SubmittedRequestsCall: "submittedRequests",
  GetProviderDetailsCall: "getProviderDetails",
  ConfirmDayStatusCall: "checkifdayconfirmed",
  AttestationStatusCall: "getAttestationStatus",
  AppointmentResyncCall: "appointmentResync",
  driveTimeEdit: "driveTimeEdit",
  AddpatientAvailabilityCall: "addPatientAvailability",
  GetPatientAvailabilityCall: "getPatientAvailability",
  patientAvailability: "patientAvailability",
  patientClinics: "patientClinics",
  rcSuggestions: "patientPortalRscSuggestions",
  rsSubmittion: "patientPortalRscBooking",
  patientCancelcall: "patientPortalCancel",
  checkptoconflicts: "checkptoconflicts",
  fetchaxoneventaddresses: "fetchaxoneventaddresses",
  fetchaddresssuggestions: "fetchaddresssuggestions",
  GetEvent: "getEvent",
  UpdateObservations: "updateObservations",
  CollectTeacherSignature: "collectTeacherSignature",
  GetTeacherSignature: "getTeacherSignature",
  getAllApprovedBloomDocuments: "getAllApprovedBloomDocuments", 
  GetSignedUrlsForBloomDocuments: "getSignedUrlsForBloomDocuments",
  DownloadBloomDocument: "downloadBloomDocument",
  GetBenefitsSummary: "getBenefitsSummary",
  MessageBenefitsTeam: "messageBenefitsTeam",
};

export { apiRequest, ApiCalls };
